export const REACT_APP_ABBR_NAME = "IALM";

export const REACT_APP_FULL_NAME = "Indian Academy of Law and Management";
